<template>
    <select name="quantity" id="quantity" class="d-inline-block form-select cursor-pointer my-1" @change="updateQuantity($event, tyre.st_code)" title="Quantity">
        <option v-for="index in 5" :key="index" :value="index" :selected="index == tyre.quantity">{{ index }}</option>
    </select>
</template>

<script>
    export default {
        props: ['tyre'],
        methods: {
            async updateQuantity(event, st_code) {
                this.emitter.emit('isLoading', true);

                let vm = this;
                var quantity = event.target.value;

                if (st_code != null && st_code != false) {
                    st_code = st_code.replace('#', '%23');
                }

                await axios.post('/ajax/update_basket_tyre_quantity/' + quantity + '/' + st_code)
                .then(response => {
                    if(response.data.basket_updated == true)
                    {
                        vm.emitter.emit('refreshBasket');

                        vm.emitter.emit('refreshServices', response.data.basket_services);
                    }
                })
                .catch(error => {
                    console.error("There was an error!", error);
                });
                
                this.emitter.emit('isLoading', false);
            },
        }
    }
</script>

<style lang="scss" scoped>

</style>